import { render, staticRenderFns } from "./StoreLocatorConfigEmpty.vue?vue&type=template&id=395ed2f1&scoped=true&"
import script from "./StoreLocatorConfigEmpty.vue?vue&type=script&lang=js&"
export * from "./StoreLocatorConfigEmpty.vue?vue&type=script&lang=js&"
import style0 from "./ConfigEmpty.scss?vue&type=style&index=0&id=395ed2f1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "395ed2f1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
